<p-popover #customizePopover [styleClass]="visibleColumns.length > 40 ? 'customize-popover' : ''" position="top" (onHide)="onClickOutReset()" (onShow)="onShow()">
    <div class="customize-container">
        <div class="item-container-grid" [ngClass]="visibleColumns.length > 10 ? 'item-container-grid' : 'item-container-flex'">
            @for (column of visibleColumns; track column) {
                @if (!column.sticky) {
                    <div class="item">
                        <p-checkbox [binary]="true" [ngModel]="!column.customizeHide" (ngModelChange)="onCheckboxChange($event, column)"></p-checkbox>
                        <span>{{column.header | translate: buildHeaderParams(column)}}</span>
                    </div>
                }
            }
        </div>
        <div class="popup-actions">
            <app-button [type]="'secondary'" [label]="'RESET'" [extraClasses]="'btn-blue-text'" (click)="onReset()" [disable]="disableUpdateBtn"></app-button>
            <app-button [type]="'primary'" [label]="'UPDATE'" (click)="onUpdate()" [disable]="disableUpdateBtn"></app-button>
        </div>
    </div>
</p-popover>